import React from 'react';

import TuneIcon from '@mui/icons-material/Tune';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';

import SearchFilter, { Condition, Filter } from 'components/condition-list/SearchFilter';

type Props = {
  conditions: Condition[];
  /** 初期フィルター（既定の絞り込み等） */
  initialFilters?: Filter[];
  onFiltersChange: (filters: Filter[]) => void;
  /** 検索条件の保存/呼び出し機能用キー */
  conditionKey?: string;
  /**
   * user_profile(AUTO) 用の profile_key（例: "member-partner-list-search"）。
   * 指定時、初期表示で「デフォルト★の次段」として最後の検索条件を復元し、
   * 検索実行のたびに保存する（SearchFilter へ委譲）。
   */
  userProfileKey?: string;
};

/**
 * コンソールテーブルのツールバーに載せる検索フィルター。
 * 3ペインの ConditionList と同様に、conditionKey 指定時は
 * 「条件設定（TuneIcon）」で条件追加ダイアログを開けるようにする。
 * （検索バー本体クリックは保存済み条件のドロップダウンを開くため、
 *  条件の新規追加導線として TuneIcon を併設する）
 */
const ConsoleSearchFilter: React.FC<Props> = ({
  conditions,
  initialFilters = [],
  onFiltersChange,
  conditionKey,
  userProfileKey,
}) => {
  const [detailDialogOpen, setDetailDialogOpen] = React.useState(false);

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ flex: 1, minWidth: 0 }}>
      {conditionKey && (
        <Tooltip title="条件設定">
          <IconButton
            size="small"
            onClick={() => setDetailDialogOpen(true)}
            sx={{ flexShrink: 0, '&:hover': { color: 'primary.main', bgcolor: 'action.hover' } }}
          >
            <TuneIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          </IconButton>
        </Tooltip>
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <SearchFilter
          filters={initialFilters}
          conditions={conditions}
          orders={[]}
          onFiltersChange={onFiltersChange}
          conditionKey={conditionKey}
          userProfileKey={userProfileKey}
          detailDialogOpen={detailDialogOpen}
          onDetailDialogClose={() => setDetailDialogOpen(false)}
        />
      </Box>
    </Stack>
  );
};

export default ConsoleSearchFilter;
